// Pages that stand in for the whole app while an account can't be used; MainLayout hides its frame on them
export const SUSPENDED = 'Suspended'
export const TRIAL_EXPIRED = 'Trial Expired'
export const CANCELED = 'Canceled'

export const BLOCKED_ROUTE_NAMES = [SUSPENDED, TRIAL_EXPIRED, CANCELED]
